import cardImg1 from 'img/icons/049-sharing.svg';
import cardImg2 from 'img/icons/005-computer.svg';
import cardImg3 from 'img/icons/045-smartphone-4.svg';
import cardImg4 from 'img/icons/009-support.svg';
import './Help.scss';
import Card from 'components/chrome/Card';
import React from 'react';


class Help extends React.Component {
  render() {
    return (
      <div className='Help'>
        <div className='section'>
          <div className='subtitle'>
            The right tools at the right time
          </div>
          <p>
            Get tips from our resource library or from the community. For those particularly sticky issues, get help directly from us.
          </p>
        </div>
        <Card
            className='section'
            direction='horizontal'
            header='Platform documentation'
            text="Here's some great text explaining what this card is all about. Perhaps the first sentence was better than the second sentence. Not all sentences are equal. Sometimes the sentences are really fantastic, though, providing unparalleled benefit to the reader."
            img={cardImg1}
            imgClassName='card1'
            imgPadded
            buttonPrimaryLabel='View the docs'
            />
        <Card
            className='section'
            direction='horizontal'
            header='Blog highlights'
            text="Here's some great text explaining what this card is all about. Perhaps the first sentence was better than the second sentence. Not all sentences are equal. Sometimes the sentences are really fantastic, though, providing unparalleled benefit to the reader."
            img={cardImg2}
            imgClassName='card2'
            imgPadded
            buttonPrimaryLabel='Visit the blog'
            />
        <Card
            className='section'
            direction='horizontal'
            header='Community forums'
            text="Here's some great text explaining what this card is all about. Perhaps the first sentence was better than the second sentence. Not all sentences are equal. Sometimes the sentences are really fantastic, though, providing unparalleled benefit to the reader."
            img={cardImg3}
            imgClassName='card3'
            imgPadded
            buttonPrimaryLabel='Visit the forums'
            />
        <Card
            className='section'
            direction='horizontal'
            header='Email or phone'
            text="Here's some great text explaining what this card is all about. Perhaps the first sentence was better than the second sentence. Not all sentences are equal. Sometimes the sentences are really fantastic, though, providing unparalleled benefit to the reader."
            img={cardImg4}
            imgClassName='card4'
            imgPadded
            buttonPrimaryLabel='Schedule a call'
            />
      </div>
    );
  }
}


export default Help;
